import React, { useEffect, useRef, useState } from 'react'
import styled from '@emotion/styled'
import { InputStyles, InputWrap, setInputTheme } from 'src/components/Input'
import { ButtonStyles } from 'src/components/Button'
import { buttonThemes } from 'src/styles/themes'
import { typography, colors, mq, globals, util } from 'src/styles'

const Wrapper = styled(globals.Card)`
  background: ${ colors.lightGrey };
  ${ util.responsiveStyles('padding', 60, 40, 24, 20) }
  box-shadow: none;
`

const StyledForm = styled.form`
  &.mktoForm {
    width: 100% !important;
    font-family: ${ typography.primaryFont } !important;
    color: inherit !important;
    padding: 0 !important;
    ${ mq.largeAndUp } {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      // &:first-of-type {
      //   display: flex;
      //   flex-wrap: wrap;
      //   margin-right: -20px;
      //   width: calc(100% + 20px) !important;
      // }
    }
    .mktoFormRow {
      flex-shrink: 0;
      width: 100%;
      &:first-of-type,
      &:nth-of-type(2) {
        ${ mq.largeAndUp } {
          width: calc(50% - 10px);
        }
      }
      &:first-of-type {
        ${ mq.largeAndUp } {
          margin-right: 20px;
        }
      }
    }
    .mktoOffset,
    .mktoGutter {
      display: none !important;
    }
    .mktoFormCol {
      float: none;
      margin-bottom: 20px !important;
    }
    .mktoFieldWrap {
      float: none;
      ${ InputWrap }
      ${ ({ inputTheme }) => setInputTheme(inputTheme) }
      display: flex;
      flex-direction: column;
      width: 100% !important;
    }
    .mktoLabel {
      float: none;
      ${ typography.bodyTiny }
      font-weight: ${ typography.medium } !important;
      color: ${ colors.lightTextColor };
      padding-left: 14px;
      display: flex;
      width: 100% !important;
      align-items: baseline;
      justify-content: flex-start;
      order: 2;
      margin: .3em 0 0;
      .mktoAsterix {
        color: ${ colors.red };
        float: none !important;
        display: inline;
        // padding: 0;
        order: 2;
      }
    }
    .mktoButtonRow {
      width: 100%;
      span {
        margin: 0 !important;
        button {
          margin-top: 20px;
          ${ ButtonStyles(false, false, 'medium', 'default') }
          ${ typography.body }
          font-weight: ${ typography.bold } !important;
          font-size: 16px !important;
          line-height: 1em !important;
          background-image: none !important;
          background: ${ buttonThemes.default.background } !important;
          border-color: ${ buttonThemes.default.background } !important;
          padding: 0 1.5em 2px !important;
          &:hover,
          &:focus,
          &:active {
            background: ${ buttonThemes.default.hoverBackground } !important;
            border-color: ${ buttonThemes.default.hoverBackground } !important;
            color: ${ buttonThemes.default.hoverColor } !important;
          }
        }
      }
    }
    input,
    select {
      ${ typography.body }
      font-size: 16px !important;
      ${ mq.mediumAndBelow } {
        font-size: 14px !important;
      }
      width: 100% !important;
      ${ InputStyles(false, 'medium', false, 'left', 'default', false) }
      padding-left: 14px !important;
      padding-right: 14px !important;
      height: 48px !important;
    }
  }
`

const ContactForm = ({
  theme,
  prevTheme,
  nextTheme,
  className,
  children,
  inputTheme = 'default',
  _rawSectionText
}) => {
	const [scriptLoaded, setScriptLoaded] = useState(false);
	const [scriptWaitCount, setScriptWaitCount] = useState(1);
	const timer = useRef(null);
  
	const waitOnMktoForms2 = () => {
		if (window.MktoForms2) {
			setScriptLoaded(true);
		} else if (scriptWaitCount > 10) {
			console.error('Could not load form!');
		} else {
			timer.current = setTimeout(() => {
				waitOnMktoForms2();
			}, 40 * scriptWaitCount);
			setScriptWaitCount(scriptWaitCount + 1);
		}
	}

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const script = document.createElement('script')
      script.src = '//256-JKX-646.mktoweb.com/js/forms2/js/forms2.min.js'
      script.async = true
			script.onload = waitOnMktoForms2;

      document.body.appendChild(script)
    }
  }, [])

	useEffect(() => {
		if (scriptLoaded && window?.MktoForms2) {
      window.MktoForms2.loadForm('//256-JKX-646.mktoweb.com', '256-JKX-646', 1002)
      const formElement = document.getElementById('mktoForm_1002')
      formElement.style = false
		}
	}, [scriptLoaded]);

  return (
    <Wrapper className={className}>
      {children}
      <StyledForm id="mktoForm_1002" inputTheme={inputTheme}></StyledForm>
    </Wrapper>
  )
}

export default ContactForm